var map = {
	"./bro_logo.png": 17347,
	"./logo-fallback-ro.svg": 26102,
	"./logo-ro.svg": 24225,
	"./markdown/Kwetsbaarheid melden.md": 34109,
	"./markdown/Toegankelijkheid.md": 98684,
	"./markdown/cookies_privacy.md": 82310,
	"./markdown/images/PDCA_Cycle.svg": 52373,
	"./markdown/images/Toegankelijkheid.png": 64510,
	"./markdown/informatie.md": 59582
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 50290;